import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@ant-design/v5-patch-for-react-19";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration =
        await navigator.serviceWorker.register('/sw.js');

      console.log(
        'Service Worker registered successfully:',
        registration.scope
      );
    } catch (error) {
      console.error(
        'Service Worker registration failed:',
        error
      );
    }
  });
}

reportWebVitals();